// extracted by mini-css-extract-plugin
export default {"infoCard":"infoCard_infoCard__A4jyK"};